//#region src/mitt.ts
/**
* Mitt: Tiny (~200b) functional event emitter / pubsub.
* @name mitt
* @returns {Mitt}
*/
function mitt(all) {
	all = all || /* @__PURE__ */ new Map();
	return {
		/**
		* A Map of event names to registered handler functions.
		*/
		all,
		/**
		* Register an event handler for the given type.
		* @param type Type of event to listen for, or `'*'` for all events
		* @param handler Function to call in response to given event
		*/
		on(type, handler) {
			const handlers = all.get(type);
			if (handlers) handlers.push(handler);
			else all.set(type, [handler]);
		},
		/**
		* Remove an event handler for the given type.
		* If `handler` is omitted, all handlers of the given type are removed.
		* @param type Type of event to unregister `handler` from (`'*'` to remove a wildcard handler)
		* @param handler Handler function to remove
		*/
		off(type, handler) {
			const handlers = all.get(type);
			if (handlers) {
				if (handler) handlers.splice(handlers.indexOf(handler) >>> 0, 1);
				else all.set(type, []);
			}
		},
		/**
		* Invoke all handlers for the given type.
		* If present, `'*'` handlers are invoked after type-matched handlers.
		*
		* Note: Manually firing '*' handlers is not supported.
		*
		* @param type The event type to invoke
		* @param evt Any value (object is recommended and powerful), passed to each handler
		*/
		emit(type, evt) {
			let handlers = all.get(type);
			if (handlers) handlers.slice().map((handler) => {
				handler(evt);
			});
			handlers = all.get("*");
			if (handlers) handlers.slice().map((handler) => {
				handler(type, evt);
			});
		}
	};
}
//#endregion
export { mitt as default };

//# sourceMappingURL=mitt.mjs.map